
{
  "fr": {
    "configurator_add_to_cart_footer": {
      "title": "Vous aimerez surement :"
    }
  }
}
